import React, { FunctionComponent } from "react";
import { useHistory } from "react-router-dom";
import { ListActionButtonProps } from "sprint-common-web";

import { movieAssetsListRoute } from "../../../../assets/AssetsRoutes";
import { ViewAssetButton } from "../../../common/components/ViewAssetButton";

export const ViewMovieAssetButton: FunctionComponent<ListActionButtonProps> = (props: ListActionButtonProps) => {
    const history = useHistory();
    const handleClick = () => {
        if (props.itemId) moveToMovieAssets(props.itemId);
    };

    const moveToMovieAssets = (tvSeriesId: string) => {
        const basePath = movieAssetsListRoute.path;
        const requiredPath = basePath?.slice(0, basePath.lastIndexOf("/"));
        history.push(`${requiredPath}/${tvSeriesId}`);
    };

    return <ViewAssetButton disabled={props.disabled} onClick={handleClick} />;
};
